import { ProfileValueOption } from '@backrs_ui/grow-ui/src/redux/profile/profile';

/**
 * Helper function to map profile values to their corresponding options
 *
 *
 */
export const mapStandardProfileArrayValues = <T extends ProfileValueOption>(
  profileValues: (string | number)[] | undefined,
  options: T[],
): T[] => {
  return (profileValues ?? [])
    .map((value) => options?.find((opt) => opt?.id === value))
    .filter((opt): opt is T => Boolean(opt));
};

/**
 * Helper function to map a single profile value to its corresponding option
 * Returns an array with the matched option or an empty array if no match is found
 */
export const mapStandardProfileSingleValue = <T extends ProfileValueOption>(
  profileValue: string | number | undefined,
  options: T[],
): T[] => {
  const option = options?.find((opt) => opt?.id === profileValue);

  return option ? [option] : [];
};
